import { render, staticRenderFns } from "./groupProducts.vue?vue&type=template&id=ab03d16e&scoped=true"
import script from "./groupProducts.vue?vue&type=script&lang=js"
export * from "./groupProducts.vue?vue&type=script&lang=js"
import style0 from "./groupProducts.vue?vue&type=style&index=0&id=ab03d16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab03d16e",
  null
  
)

export default component.exports